import { usePortalLocale } from "./usePortalLocale";

/** Learn tab hook — delegates to unified portal locale (SC-17). */
export function useLearnLocale(enabled = true) {
  const portal = usePortalLocale(enabled);
  return {
    locale: portal.locale,
    setLocale: portal.setLocale,
    strings: portal.strings,
    prefs: portal.prefs,
    prefsLoading: portal.prefsLoading,
  };
}
